export const IMAGE_URL = 'https://image.tmdb.org/t/p/w500';
export const STORAGE_KEY_WATCHED = 'watchedMovies';
export const STORAGE_KEY_QUEUE = 'queueMovies';
